import { render, staticRenderFns } from "./VeImageBlock.vue?vue&type=template&id=20a5eb9f&scoped=true"
import script from "./VeImageBlock.vue?vue&type=script&lang=js"
export * from "./VeImageBlock.vue?vue&type=script&lang=js"
import style0 from "./VeImageBlock.vue?vue&type=style&index=0&id=20a5eb9f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5eb9f",
  null
  
)

export default component.exports